import { ThirdwebSDK } from "@thirdweb-dev/sdk";

export const clientId = "aca5cbc2a8becd4d4602dfcc71e09be1";
export const sdk = new ThirdwebSDK("base", { clientId });
